import { Link as GatsbyLink } from 'gatsby'
import styled, { css } from 'styled-components'
import { color, Media, spacing, typography } from '../../style'

export const Wrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  line-height: 2.5;
  padding-top: 50px;
  color: ${color.textDark};
  font-size: ${typography.textSmall};
  ${Media.lessThan(Media.small)} {
    flex-wrap: wrap;
    padding-top: 20px;
    flex-direction: column-reverse;
  }
`
export const Desc = styled.div`
  line-height: 24px;
  margin-top: ${spacing.base};
  ${Media.lessThan(Media.small)} {
    display: none;
  }
`
export const Part = styled.div`
  width: ${(p) => p.width};
  display: flex;
  flex-wrap: wrap;
  > div:first-child {
    margin-right: 30px;
  }
  > div:nth-child(2) {
    padding-left: 60px;
  }
  ${Media.lessThan(Media.small)} {
    width: 100%;
    > div {
      margin-right: 0;
    }
    > div:nth-child(2) {
      padding-left: 0;
    }
  }
`
export const Title = styled.h5`
  color: white;
  margin: 0;
  line-height: 3;
  font-size: ${typography.text};
`
export const MobileAddr = styled.div`
  line-height: 1.5;
  ${Media.lessThan(Media.small)} {
    display: none;
  }
`
export const Addr = styled.p`
  display: none;
  width: 100%;
  text-align: right;
  padding-right: 100px;
  ${Media.lessThan(Media.small)} {
    display: block;
    text-align: center;
    padding-right: initial;
  }
`
const CommonLink = css`
  text-decoration: none;
  color: ${color.textDark};
  :hover {
    color: ${color.primary};
  }
`
export const Anchor = styled.a`
  ${CommonLink};
`
export const Link = styled(GatsbyLink)`
  ${CommonLink};
`
export const Record = styled.p`
  text-align: center;
  width: 100%;
  margin: 0;
  line-height: 3;
  font-size: ${typography.textThin};
  border-width: 1px;
  border-style: solid;
  border-image: linear-gradient(to right, transparent, ${color.textDark}, transparent) 100% 0 0;
`
export const Footer = styled.footer`
  background-color: ${color.panel};
`
